import React, { useEffect, useMemo, useState } from 'react';
import styles from '../App.module.css';
import api from '../api/axios';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { isAuthenticated } from '../index';

export default function DSEditor() {
    const { userCpf } = isAuthenticated();

    const estruturaBase = useMemo(() => ({
        nome: '',
        sobrenome: '',
        nomeEmpresa: '',
        endereco1: '',
        endereco2: '',
        cidade: '',
        estado: '',
        cep: '',
        palavraSecreta: '',
        email: '',
        senha: ''
    }), []);

    const camposExplicados = useMemo(() => ({
        nome: { label: "Nome", descricao: "" },
        sobrenome: { label: "Sobrenome", descricao: "" },
        nomeEmpresa: { label: "Nome da Empresa", descricao: "" },
        endereco1: { label: "Endereço (linha 1)", descricao: "Rua, número e complemento principal." },
        endereco2: { label: "Endereço (linha 2)", descricao: "Complemento opcional (bloco, apto, etc)." },
        cidade: { label: "Cidade", descricao: "" },
        estado: { label: "Estado", descricao: "" },
        cep: { label: "CEP", descricao: "Código postal (somente números)." },
        palavraSecreta: { label: "Palavra Secreta", descricao: "Palavra usada para verificação de segurança do DS-160." },
        email: { label: "E-mail Padrão", descricao: "Endereço de e-mail para criar contas no site de agendamento." },
        senha: { label: "Senha Padrão", descricao: "Senha padrão para criar conta no site de agendamento." }
    }), []);

    const [dadosUsuario, setDadosUsuario] = useState(estruturaBase);

    useEffect(() => {
        async function fetchUserData() {
            try {
                const res = await api.get(`/usuarioLogado?userCpf=${userCpf}`);
                const data = res.data || {};
                const dadosCompletos = { ...estruturaBase, ...data };
                setDadosUsuario(dadosCompletos);
            } catch (error) {
                NotificationManager.error('Erro ao buscar dados do usuário.');
            }
        }

        if (userCpf) {
            fetchUserData();
        }
    }, [userCpf, estruturaBase]);

    function handleChange(e) {
        const { name, value } = e.target;
        setDadosUsuario((prev) => ({ ...prev, [name]: value }));
    }

    async function salvarAlteracoes() {
        try {
            const res = await api.post('/usuario/update', { ...dadosUsuario, userCpf });

            if (res.data?.success) {
                NotificationManager.success('Dados atualizados com sucesso!');
            } else {
                NotificationManager.error('Erro ao salvar.');
            }
        } catch (error) {
            NotificationManager.error('Erro de conexão ao salvar.');
        }
    }

    return (
        <div className={styles.app}>
            <NotificationContainer />
            <div className={styles.cadastroClienteContainer}>
                <div style={{ padding: "20px", width: "80%", maxWidth: "600px", textAlign: "center" }}>
                    <h2 className={styles.titulo}>
                        Informações para preenchimento automático do DS-EDITOR
                    </h2>
                </div>

                {Object.keys(estruturaBase).map((campo) => (
                    <div
                        key={campo}
                        className={styles.inputContainer}
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "20px"
                        }}
                    >
                        <div style={{ width: "80%" }}>
                            <label className={styles.inputText}>
                                {camposExplicados[campo]?.label || campo}
                            </label>
                            <small
                                style={{
                                    color: "#777",
                                    fontSize: "0.9em",
                                    marginLeft: "5px",
                                    display: "block"
                                }}
                            >
                                {camposExplicados[campo]?.descricao || ""}
                            </small>
                        </div>

                        <div style={{ width: "80%" }}>
                            <input
                                className={styles.inputFilter}
                                style={{
                                    padding: "10px",
                                    width: "100%",
                                    borderRadius: "10px"
                                }}
                                type={campo === 'senha' ? 'password' : 'text'}
                                name={campo}
                                value={dadosUsuario[campo] || ''}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                ))}

                <button className={styles.cadastroCliente} onClick={salvarAlteracoes}>
                    Salvar Alterações
                </button>
            </div>
        </div>
    );
}